import { render, staticRenderFns } from "./LiveAccount.vue?vue&type=template&id=6c792a14"
import script from "./LiveAccount.vue?vue&type=script&lang=js"
export * from "./LiveAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports